import axios, {AxiosError, AxiosResponse} from "axios";

interface SuccessResponse {
    success: boolean
    message: any
}

export default class NewsletterForm {

    form: HTMLFormElement
    send: boolean = false;

    constructor(form: HTMLFormElement) {
        this.form = form;
        this.initEvents();
        this.setMessage('');
    }

    initEvents() {
        this.form.querySelector<HTMLInputElement>('input[name=email]')?.addEventListener('change', () => {
            this.form.querySelectorAll<HTMLButtonElement>('button').forEach(button => button.disabled = false);
        })
        this.form.addEventListener('submit', e => {
            e.preventDefault();

            let data = new FormData(this.form);
            let HONEYPOT = data.get('_email') ? data.get('_email').toString() : null;

            data.set('action', codepress.form_newsletter_request.action)
            data.set('nonce', codepress.form_newsletter_request.nonce)

            if (HONEYPOT !== null) {
                return;
            }

            if (this.send) {
                return;
            }

            data.delete('_email');

            this.form.querySelectorAll('button').forEach(el => {
                el.classList.add('ajax-loading');
            });

            subscribeCommand(data).then((response: AxiosResponse<SuccessResponse>) => {
                if (response.data.success) {
                    this.setMessage(response.data.message)
                }
                this.form.querySelectorAll('button').forEach(el => {
                    el.classList.remove('ajax-loading');
                    el.disabled = true;
                });
                this.send = true;

            }).catch((error: AxiosError) => {
                this.setMessage(error.response.data)
            });
        });
    }

    setLoading() {

    }

    setMessage(message: string = null): void {
        this.form.querySelectorAll<HTMLElement>('[data-message]').forEach(element => {
            element.innerHTML = message;
            element.style.display = message ? 'block' : 'none';
        });
    }

}

const subscribeCommand = (data: FormData) => {


    return axios.post(window.location.toString(), data);
}